export default __webpack_public_path__ + "static/media/slider-9.5bb0873e.png";